// src/pages/app/Logout.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../pages/app/protected/firebase';

const Logout = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const logout = async () => {
      try {
        await signOut(auth);
        localStorage.removeItem('cashmate-remember-me');
        navigate('/login', { replace: true });
      } catch (error) {
        console.error('Error during logout:', error);
        navigate('/login', { replace: true });
      }
    };

    logout();
  }, [navigate]);

  return null;
};

export default Logout;